import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { authConfig } from "./auth.config";
import { BehaviorSubject } from "rxjs";
import { FilingService } from "src/api/services";
import { PreviousFilingIdService } from "./shared/filingId.service";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  private usernameSubject = new BehaviorSubject<string | null>(
    localStorage.getItem("name")
  );
  username$ = this.usernameSubject.asObservable();
  muser: any;

  constructor(
    private _router: Router,
    private httpClient: HttpClient,
    private oauthService: OAuthService,
    private filingService: FilingService,
    private previousFilingIdService: PreviousFilingIdService
  ) {
    this.configureWithNewConfigApi();
  }

  private configureWithNewConfigApi() {
    this.oauthService.configure(authConfig);
    this.oauthService.events.subscribe((e) => {
      if (e.type === "token_received") {
        const returnUrl = localStorage.getItem("/");
        localStorage.setItem("returnUrl", "/");
        this.getUser();
        // @ts-ignore
        this._router.navigateByUrl(returnUrl);
      }
    });
    this.oauthService.setStorage(localStorage);
    this.oauthService.oidc = false;
    this.oauthService.tryLogin({
      onTokenReceived: (context) => {
        console.log("context");
      },
    });
  }

  public obtainAccessToken() {
    this.oauthService.initImplicitFlow();
    this.getUser();
  }

  public isLoggedIn() {
    if (this.oauthService.getAccessToken() === null) {
      return false;
    }
    return this.oauthService.getAccessTokenExpiration() > new Date().getTime();
  }

  public isAccessTokenPresent() {
    if (this.oauthService.getAccessToken() !== null) {
      return (
        this.oauthService.getAccessTokenExpiration() > new Date().getTime()
      );
    }
    return false;
  }

  public logout() {
    let tokenUrl = authConfig.loginUrl;
    // @ts-ignore
    tokenUrl = tokenUrl.replace("/oauth/authorize", "/my/oauth/token");
    const headers = new HttpHeaders().set(
      "Authorization",
      "Bearer " + this.oauthService.getAccessToken()
    );

    this.httpClient
      .delete(tokenUrl, {
        headers: headers,
      })
      .subscribe({
        next: (response) => {
          this.oauthService.logOut();
          this._router.navigate(["login"]);
        },
        error: (error) => {
          this.clearSession();
        },
        complete: () => {
          this.clearSession();
        },
      });
  }

  public getUser() {
    const headers = new HttpHeaders().set(
      "Authorization",
      "Bearer " + this.oauthService.getAccessToken()
    );
    this.httpClient
      .get(authConfig.userinfoEndpoint as string, { headers })
      .subscribe({
        next: (response) => {
          this.muser = response;
        },
        error: (error) => {
          console.log(error);
        },
        complete: () => {
          const username = this.muser.email;
          localStorage.setItem("name", this.muser.name);
          localStorage.setItem("email", this.muser.email);
          this.usernameSubject.next(this.muser.name); // Notify
          //  Call your Filing API here
          this.filingService.getLastFilingByUser(username).subscribe({
            next: (res) => {
              const filingId = res.filingId;
              const filingState = res.filingState;
              if (filingId !== undefined) {
                this.previousFilingIdService.setPreviousFiling(
                  filingId.toString(),
                  filingState ?? "MANUAL_CHECK"
                );
              }
            },
            error: (err) => {
              console.error("Failed to get last filing by user", err);
            },
          });
        },
      });
  }

  public clearSession() {
    this._router.navigate(["login"]).then((value) => {
      localStorage.removeItem("access_token");
      localStorage.removeItem("userId");
      localStorage.removeItem("nonce");
      localStorage.removeItem("expires_at");
      localStorage.removeItem("isAdmin");
      localStorage.removeItem("access_token_stored_at");
      localStorage.removeItem("picture");
    });
  }
}
